import React from 'react';
import ReactDOM from 'react-dom';
import ReactDOMServer from 'react-dom/server';
import Dict from 'dict-lib';
import ReactCSSTransitionGroup from 'react-addons-css-transition-group';
import LexemePage, {getLexemeProperties} from '../lexeme/page/LexemePage';
import {Button, ListGroup, Modal, Row} from 'react-bootstrap';
import {ListGroupItem} from 'react-bootstrap';
import {Pagination} from 'react-bootstrap';
import {performSearch} from "./lib/search";
import FontAwesome from "react-fontawesome";
import ReactTooltip from "react-tooltip";
import {PhraseEditor} from "../lexeme/page/editor/phrases/PhraseEditor";
import {LexemeUtilities, LexemeEditingLevel,} from "../lexeme/page/editor/LexemeHelper";
import {userService} from "../_redux/authentication/services/user.services";

import stylesSearchPage from '../_css/dictionary/searchPage.module.css';
import BUtils from './../utilities/BaseUtilities';
import {DictionaryHelper, DictionarySettings, Notifications} from "../utilities/DictUtilities";
import error from "../../public/img/error.png";
import warning from "../../public/img/warning.png";
import {SCModalMessage} from "../dict-components/modal/SCModalMessage/SCModalMessage";
import {SearchExportModal} from "./SearchExportModal";
import {AdministrationUtilities} from "../administration/AdministrationHelper";

export class SearchResult extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            listItems: '',
            activePage: this.props.nPage,
            selectedId: '',
            selectedSemanticUnitId: '',
            newUpdateIds: [],
            export: {status: 'stop'},
            searchParams: this.props.searchParams,
            stylesCustom: {}
        };

        this.enableExport = Dict.getGlobalProperty('ENABLE_EXPORT') === 'true';

        this._handleSelect = this._handleSelect.bind(this);
        this._launchExport = this._launchExport.bind(this);
        this.showLexemeInAltForms = Dict.getLanguageOptionsById(this.props.language.id)["dictionaryTypesLemmata->SHOW_LEXEME_IN_ALT_FORMS"]
        /*this.noAltFormsChoice = Dict.getLanguageOptionsById(this.props.language.id)["dictionaryTypesLemmata->NO_ALT_FORMS"]*/
        this.altFormToEditMain = typeof this.showLexemeInAltForms !== 'undefined' && this.showLexemeInAltForms !== 'false';
        this.altFormLinkedToMain = this.altFormToEditMain && this.showLexemeInAltForms === 'ALT_FORMS_LINKED_TO_MAIN';
        this.isEncyclopedic = AdministrationUtilities.isEncyclopedic();
    }

    componentWillMount() {
        const custom_layout = Dict.getVarious('custom_layout');
        if (custom_layout.use_custom_layout) {
            DictionarySettings.getCustomLayout(this.state.styleCustom, (stylesCustom) => {
                this.setState({stylesCustom});
            })
        }
    }

    componentWillReceiveProps(nextProps, nextContext) {
        this.setState({
            selectedId: '',
            export: {status: 'stop'}
        });
    }

    _scrollTo(pos) {
        this.scroll.scrollToY(pos);
    }

    _handleSelect(eventKey) {
        if (eventKey > 0) {
            this.setState({
                activePage: eventKey,
                selectedId: ''
            }, function () {
                performSearch({nPage: eventKey, langId: this.props.language.id});
            });
        }
    }

    _launchExport(isOnlyStructure) {
        var exp = {status: 'start'};
        this.setState({export: exp});
        const totalPages = this.props.result.totalPages > 0 ? this.props.result.totalPages : (this.props.result.items.length > 0 ? 1 : 0);
        LexemeUtilities.exportLexemePages(this.props.searchParams, totalPages, this.props.language.id, this.props.dictionaryType, () => {
            this.setState({export: {status: 'finished'}});
        });
    }

    render() {

        var stylesCustom = this.state.stylesCustom;
        var items = this.props.result.items;
        var totalPages = this.props.result.totalPages;

        var listItems = [];
        var ulKey = '';
        for (var i = 0; i < items.length; i++) {
            var resultItem = items[i];
            var resultItemId = resultItem.fields.id;
            var resultItemSemanticUnitId = typeof resultItem.fields.semanticUnitId !== 'undefined' && resultItem.fields.semanticUnitId !== 'null' ? resultItem.fields.semanticUnitId : '';
            ulKey += resultItemId + "_";
            listItems.push(<SearchResultItem key={"search-result-key-" + resultItemId + i} resultItem={resultItem}
                                             showLanguage={this.props.language.is_tree}
                                             isSelected={resultItemId === this.state.selectedId}
                                             itemsLenght={items.length}
                                             isNewUpdateId={this.state.newUpdateIds.indexOf(resultItemId) > 0}
                                             isBySemanticUnitSelected={resultItemSemanticUnitId === this.state.selectedSemanticUnitId}
                                             searchType={this.props.result.searchType}
                                             viewPoint={this.props.language}
                                             altFormToEditMain={this.altFormToEditMain}
                                             altFormLinkedToMain={this.altFormLinkedToMain}
                                             polyId={this.props.polyId}
                                             callbackParentSelect={(selectedId, selectedSemanticUnitId) => this.setState({
                                                 selectedId,
                                                 selectedSemanticUnitId
                                             })}
                                             callbackParentUpdate={(newUpdateId) => {
                                                 var newUpdateIds = BUtils.cloneJson(this.state.newUpdateIds)

                                                 if (newUpdateIds.indexOf(newUpdateId) === -1) {
                                                     newUpdateIds.push(newUpdateId)
                                                 }

                                                 this.setState({
                                                     newUpdateIds
                                                 })
                                             }}
            />);
        }

        const foundItems = listItems.length > 0;
        if (!foundItems) {
            ulKey = "noResultFound";
            listItems.push(<div key={"key-search-no-object-found"}
                                style={{fontWeight: 'bold'}}>{Dict.t('NO_OBJECT_FOUND')}</div>);
            setTimeout(function () {
                listItems = [];
                document.getElementById("dict-result-container").innerHTML = "";
            }.bind(this), 5000);
        }


        let pagItems = [];
        var drawButton = true;
        const nPage = this.props.nPage;
        var lastNumber = 0;

        for (let number = 1; number <= totalPages; number++) {
            if (nPage <= 2 && number <= 3) {
                drawButton = true;
            } else {
                var abs = Math.abs(number - nPage);
                var totAbs = Math.abs(number - totalPages);

                if (totalPages <= 4 || totAbs < 1) {
                    drawButton = true;
                } else if (nPage >= 3 && abs < 2) {
                    drawButton = true;
                } else {
                    drawButton = false;
                    if (abs < 3 || (nPage === 1 && number === 4)) {
                        pagItems.push(<Pagination.Ellipsis key={'key-page-item-' + number}/>);
                    }
                }
            }

            if (drawButton) {
                lastNumber = number;
                pagItems.push(
                    <Pagination.Item active={number === nPage} key={'key-page-item-' + number}
                                     onClick={() => this._handleSelect(number)}>{number}</Pagination.Item>);
            }

            drawButton = true;
        }

        if (lastNumber !== totalPages) {
            pagItems.push(
                <Pagination.Item
                    key={'key-page-item-' + totalPages}
                    onClick={() => this._handleSelect(totalPages)}>{totalPages}</Pagination.Item>);
        }

        return <div className={stylesSearchPage['pagination-container']} key={'pag-con-' + Math.random()}>
            <div
                className={BUtils.joinClasses(stylesSearchPage['pagination-tot-container'], stylesCustom['custom-pagination-tot-container'])}>
                <Pagination bsSize="small" onSelect={this._handleSelect} key={'key-pagination'}>
                    <Pagination.First onClick={() => this._handleSelect(1)} key={'key-pagination-first'}/>
                    <Pagination.Prev onClick={() => this._handleSelect(nPage > 1 ? this.props.nPage - 1 : -1)}
                                     key={'key-pagination-prev'}/>
                    {pagItems}
                    <Pagination.Next onClick={() => this._handleSelect(nPage < totalPages ? this.props.nPage + 1 : -1)}
                                     key={'key-pagination-next'}/>
                    <Pagination.Last onClick={() => this._handleSelect(totalPages)} key={'key-pagination-last'}/>
                </Pagination>
                <span
                    className={stylesSearchPage['pagination-tot-container__span']}>Tot:{this.props.result.totalItems}</span>
            </div>
            <ListGroup id="dict-result-list"
                       className={BUtils.joinClasses(stylesSearchPage['dict-result-list'], stylesSearchPage['dict-result-list--' + this.props.result.searchType], stylesSearchPage['dict-result-list-encyclopedic--' + this.isEncyclopedic])}
                       key={'key-listgroup'}>
                {listItems}
            </ListGroup>
            <Row
                className={BUtils.joinClasses(stylesSearchPage['dict-result-list-buttons'], stylesSearchPage['dict-result-list-buttons--' + foundItems])}>
                <FontAwesome name={"spinner"}
                             className={BUtils.joinClasses(stylesSearchPage['dict-result-list-buttons__spinner'], stylesSearchPage['dict-result-list-buttons__spinner--' + (this.state.export.status === 'start')])}
                             spin/>
                <span id={'bt-search-export-counter'}
                      className={BUtils.joinClasses(stylesSearchPage['dict-search-result-export-counter'], stylesSearchPage['dict-search-result-export-counter--' + (this.state.export.status === 'start')])}>0%</span>
                <Button id={'bt-search-result-open-export'}
                        className={BUtils.joinClasses(stylesSearchPage['dict-result-list-buttons__button'], stylesSearchPage['dict-result-list-buttons__button--' + (this.state.export.status === 'finished')])}
                        onClick={() => {
                            ReactDOM.render('', document.getElementById('dict-modal-container'),
                                () => {
                                    ReactDOM.render(<SearchExportModal
                                        show={true}/>, document.getElementById('dict-modal-container'))
                                });

                            //LexemeUtilities.showDownloadableHtmlModalMessage(document.getElementById("export-split-part1").innerHTML, {additionalProps: {divide: 10}});
                        }}>{Dict.t('OPEN')}</Button>
                {this.enableExport ? <Button id={'bt-search-result-export'}
                                             className={stylesSearchPage['dict-result-list-buttons__button']}
                                             onClick={() => {
                                                 this._launchExport()
                                             }}>{Dict.t('EXPORT')}</Button> : ''}
            </Row>
        </div>
    }
}

class SearchResultItem extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            id: '',
            isUpToDate: true, /*this.props.resultItem.fields.jsonPageUpToDate || this.props.isNewUpdateId,*/
            entryFormView: this.props.resultItem.fields.entryForm,
            resultItem: this.props.resultItem.fields,
            isDeleted: false
        };

        this._handleClick = this._handleClick.bind(this);
        this._handlePhraseClick = this._handlePhraseClick.bind(this);

        this.hasErrors = this.props.resultItem.fields.hasErrors;
        this.pageNotComplete = this.hasErrors || !this.state.isUpToDate;
        this.pageInReview = !userService.isLogged() && this.pageNotComplete;
        this.isEncyclopedic = AdministrationUtilities.isEncyclopedic();
    }

    _handleClick() {

        this.props.callbackParentSelect(this.props.resultItem.fields.id, this.props.resultItem.fields.semanticUnitId);
        const rifs = this.props.resultItem.fields;
        const isAltForm = rifs.isAlternativeForm;
        const toEdit = userService.isLogged() && (!isAltForm || this.props.altFormLinkedToMain);
        const altFormLinkedToMain = isAltForm && this.props.altFormLinkedToMain;
        const pageStatus = this.props.resultItem.fields.isExternalDict ? LexemeEditingLevel.EXTERNAL_DICTIONARY_ENTRY : toEdit ? LexemeEditingLevel.EDITABLE : LexemeEditingLevel.READ_ONLY;
        const lang = this.props.viewPoint;
        const callback = () => {
            this.props.callbackParentUpdate(this.props.resultItem.fields.id);
            var scrollId = '';
            var prefixId = '';
            if (this.props.searchType === 'POLIES') {
                scrollId = this.props.resultItem.fields.polyId;
                prefixId = 'div-poly-';
            } else if (this.props.searchType === 'SENSES') {
                scrollId = this.props.resultItem.fields.senseId;
                prefixId = 'su-ids-';
            }

            if (scrollId !== '') {
                document.getElementById(prefixId + scrollId).scrollIntoView({behavior: "smooth"});
                if (Dict.getGlobalProperty('DICTIONARY->ENCYCLOPEDIC_DICTIONARY_TYPE') === 'NONE')
                    LexemeUtilities.performHighlight(prefixId, scrollId);
            }
        };

        if (this.hasErrors && !userService.isAdministrator())
            Notifications.showErrorModalMessage((this.pageInReview ? 'SEARCH_RESULT_PAGE_IN_REVIEW' : 'SEARCH_ERROR_RESULT_TOOLTIP_ABBR'), 3000);
        else {
            var form = '';
            if (isAltForm) {
                form = altFormLinkedToMain ? rifs.mainForm : rifs.entryForm + ' ' + rifs.abstr;
            } else {
                form = rifs.entryForm;
            }

            LexemeUtilities.openLexemePage(rifs.id, rifs.rootEntryId, this.state.isUpToDate, pageStatus, form, this.props.dictionaryType, rifs.abstr, lang.id, lang.code, undefined, callback);
        }
        /*LexemeUtilities.exportLexemePage(rifs.id, rifs.rootEntryId, this.state.isUpToDate, rifs.entryForm, this.props.dictionaryType, rifs.entryAbstr, lang.id, lang.code, () => {
        var res = '';
        var css = document.getElementsByTagName('style');
        for (let styleItem of css) {
        res += styleItem.outerHTML;
        }
        res += document.getElementById("lexeme-tabs-pane-0").innerHTML;
        console.log(res);
        });*/
    }

    _handleDescrMouseOver(e) {
        var isOverflow = e.target.offsetWidth < e.target.scrollWidth;
        if (isOverflow)
            e.target.classList.add(stylesSearchPage['span-entry-descr-overflow']);
    }

    _handleDescrMouseOut(e) {
        e.target.classList.remove(stylesSearchPage['span-entry-descr-overflow']);
    }

    _handleClickPhraseLexeme(id) {
        const LexemePageConst = <LexemePage key={"key-lexeme-page-" + id}
                                            id={id} isUpToDate={this.state.isUpToDate}
                                            pageStatus={'EDITABLE'} dictionaryType={this.props.dictionaryType}
                                            entryAbstr={''}
                                            language={this.props.viewPoint}
                                            rootEntryId={id}
        />;
        ReactDOM.render(LexemePageConst, document.getElementById("lexeme-page-container"));
    }

    _handlePhraseClick(id) {
        if (!this.state.isDeleted) {
            const PhraseEditorConst = <PhraseEditor key={"key-phrase-editor-" + id}
                                                    phraseId={id}
                                                    searchType={this.props.searchType}
                                                    phraseResultItem={this.state.resultItem}
                                                    lang={this.props.viewPoint}
                                                    container={"phrase-editor-lexeme-container"}
                                                    callbackParentResetResult={(resultItem) => this.setState({resultItem})}
                                                    callbackParentRemoveItem={() => {
                                                        this.setState({isDeleted: true})
                                                    }}
            />;

            ReactDOM.render(PhraseEditorConst, document.getElementById("lexeme-page-container"));
        } else {
            Notifications.showErrorModalMessage("OBJECT_IS_DELETED", 2000);
        }
    }

    render() {
        var resultItem = this.state.resultItem;
        const isPhrase = this.props.searchType === 'PHRASES';
        const isSense = this.props.searchType === 'SENSES';
        const isSemanticSearch = this.props.searchType === 'SENSES' || isPhrase;
        const id = this.props.resultItem.fields.id/* + (isSense ? "-" + resultItem.semanticUnitId : '')*/;
        const isHidden = resultItem.hideView;
        const isExternal = this.props.resultItem.fields.isExternalDict;

        const isSelected = this.props.isSelected && (!isSemanticSearch || this.props.isBySemanticUnitSelected);

        const Language = <div
            className={BUtils.joinClasses(stylesSearchPage['dict-result-entryDescr__language'], stylesSearchPage['dict-result-entryDescr__language__language--'] + this.props.showLanguage ? 'show' : 'hide')}>({resultItem.language})</div>;

        const groupId = "dict-result-item-" + id;
        var groupClassName = BUtils.joinClasses(stylesSearchPage['dict-result-item'], stylesSearchPage['dict-result-item--' + (isSelected ? 'selected' : 'not-selected')], (isHidden ? stylesSearchPage['dict-result-item--hidden'] : ''));

        //TODO: da ritestare dopo block join
        /*if (this.props.searchType === 'PHRASES') {
            const LexemesLine = resultItem.lexemes.map(item => {
                return <div onClick={() => this._handleClickPhraseLexeme(item.id)}>{item.label}</div>
            });

            return <ListGroupItem id={groupId}
                                  className={groupClassName}
            >
                <div
                    className={BUtils.joinClasses(stylesSearchPage['dict-result-field'], stylesSearchPage['dict-result-phrase'], this.state.isDeleted ? stylesSearchPage['dict-result-phrase--deleted'] : '')}
                    onClick={() => this._handlePhraseClick(id)}
                    dangerouslySetInnerHTML={{__html: resultItem.phraseText}}/>
                <div
                    className={BUtils.joinClasses(stylesSearchPage['dict-result-field'], stylesSearchPage['dict-result-phrase-lexeme'])}>{LexemesLine}</div>
            </ListGroupItem>;
        } else*/ {

            const lexemeClassNames = " dict-rootentry-" + (resultItem.rootEntryId) + " search-type-" + this.props.searchType;
            groupClassName += " " + lexemeClassNames;
            const homo = parseInt(resultItem.homographic);

            //const homoSplit = resultItem.rootEntryFormForSorting.split('^');
            //homo = parseInt(homoSplit[homoSplit.length - 1]);

            const idTooltip = 'search-result-tooltip-' + id;
            const Tooltip = !this.pageNotComplete ? '' :
                <span id={'dict-result-item-tooltip-' + id}
                      className={stylesSearchPage['dict-result-item-tooltip']}><FontAwesome
                    name={"exclamation-triangle"}
                    className={BUtils.joinClasses(stylesSearchPage["search-result-tooltip-img"], stylesSearchPage["search-result-tooltip-img--" + (this.hasErrors || this.pageInReview ? 'error' : 'warning')])}
                    data-tip
                    data-for={idTooltip}/>
                            <ReactTooltip id={idTooltip} className={stylesSearchPage["search-result-tooltip"]}
                                          type={this.hasErrors ? 'error' : 'info'}>
                            <span>{Dict.t(this.pageInReview ? 'SEARCH_RESULT_PAGE_IN_REVIEW' : this.hasErrors ? 'SEARCH_ERROR_RESULT_TOOLTIP' : 'SEARCH_RESULT_TOOLTIP')}</span>
                            </ReactTooltip></span>;

            const idEntryForm = 'result-entryForm-' + id;
            const classEntryForm = stylesSearchPage['dict-result-entryForm-has-errors--' + this.hasErrors];
            const topic = resultItem.topics !== null && resultItem.topics.length > 0 ? AdministrationUtilities.printTopics(resultItem.topics, 'unique') : '';
            const EntryForm = resultItem.htmlEntryForm != null && Object.keys(resultItem.htmlEntryForm).length > 0 ?
                <span id={idEntryForm} className={classEntryForm}
                      dangerouslySetInnerHTML={{__html: resultItem.htmlEntryForm}}/> :
                <span className={classEntryForm} onMouseOver={(e) => this._handleDescrMouseOver(e)}
                      onMouseOut={(e) => this._handleDescrMouseOut(e)}
                      id={idEntryForm}>{resultItem.entryForm/*resultItem.isAlternativeForm ? resultItem.entryForm + ' ⇒ ' + resultItem.mainForm : resultItem.entryForm*/}</span>;
            const Topic = <span className={stylesSearchPage['dict-result-item-topic']}
                                dangerouslySetInnerHTML={{__html: topic}}/>;

            const isToponym = typeof resultItem.discriminator !== 'undefined' && resultItem.discriminator === 'TOPONYM';
            var abstrText = resultItem.abstr == null ? "&nbsp;" : resultItem.abstr.replace('<hightlight-search-result>', '').replace('</hightlight-search-result>', '');
            const abstr = isToponym ? <FontAwesome name={'map-signs'}/> :
                <span dangerouslySetInnerHTML={{__html: abstrText}}/>;

            return <ListGroupItem id={groupId}
                                  className={groupClassName}
                                  onClick={this._handleClick}>
                {userService.isLogged() && !this.isEncyclopedic ? <div
                    className={BUtils.joinClasses(stylesSearchPage['dict-result-field'], stylesSearchPage['dict-result-status'])}
                    data-status={resultItem.lexemeStatus}>
                    <div className={stylesSearchPage['dict-result-status-color']}/>
                </div> : ''}
                <div
                    className={BUtils.joinClasses(stylesSearchPage['dict-result-field'], stylesSearchPage['dict-result-entry-descr'], stylesSearchPage['dict-result-entry-descr-is-external--' + isExternal], stylesSearchPage['dict-result-entry-descr__encyclopedic--' + this.isEncyclopedic])}>{Tooltip}{EntryForm}
                    <sup id={'dict-result-item-sup-' + id}
                         className={stylesSearchPage['dict-result-entry-descr-homo--' + (homo > 0)]}>{homo}</sup>
                    {Topic}
                    <br/>
                    {Language}
                </div>
                <div id={'dict-result-item-entryAbstr-' + id}
                     className={BUtils.joinClasses(stylesSearchPage['dict-result-field'], stylesSearchPage['dict-result-entryAbstr'], stylesSearchPage['dict-result-entryAbstr__encyclopedic--' + this.isEncyclopedic])}>{abstr}</div>
            </ListGroupItem>
        }
    }
}

